<template>
  <v-dialog
    v-model="dialog"
    class="pa-0 ma-0 dialog-hidden"
    :width="qrViewer ? 1000 : ''"
  >
    <div class="back-white  mt-3  pa-0  border-white">
      <v-row class="  ma-0 pa-0 pt-3 pb-2 justify-center  back-556C96">
        <span class="align-center pl-3 ">
          <h3 class="color-white ">입고 등록 수정</h3>
        </span>
      </v-row>
      <div class="area-title pt-5 pb-2 ml-3">
        {{ "현장명  : " + constructionName }}
      </div>

      <v-row
        class="ma-0 pa-0 ml-3 mt-2 mb-2 d-flex justify-space-between"
        v-if="!qrViewer"
      >
        <div class="d-flex align-center">
          <div class="store-date-title mr-3">입고일자</div>
          <v-dialog ref="dialog" v-model="modal" width="388px">
            <template v-slot:activator="{ on, attrs }">
              <div class="width179-height35 align-center">
                <v-text-field
                  v-model="date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  class="ma-0 pa-0"
                  outlined
                  dense
                  :disabled="viewerRole || closeYn"
                ></v-text-field>
              </div>
            </template>

            <DefaultDatePicker
              @update:date="updateReceivedDate"
              @close:date="modal = false"
              :resetDate="dueDate"
            />
          </v-dialog>
        </div>

        <div v-if="closeYn" class="mr-4">
          <div class="done-text">
            <v-icon size="16" color="#FF2626" class="mr-1"
              >mdi-message-alert</v-icon
            >
            이 데이터는 마감되었습니다.
          </div>
          <div class="info-text">
            해제를 원하시면 본사 담당자에게 요청하세요.
          </div>
        </div>
      </v-row>
      <v-row
        justify-center
        align-center
        class="ml-3 mr-3 ma-0 pa-0"
        v-if="!qrViewer"
      >
        <v-simple-table
          class="width-100 border-aaaaaa"
          fixed-header
          dense
          style="max-height:300px;overflow:auto"
        >
          <thead>
            <tr class="back-8ca9dd">
              <th
                class="text-center back-8ca9dd color-white border-right-white "
                rowspan="2"
              >
                발주차수
              </th>
              <th
                class="text-center back-8ca9dd color-white border-right-white"
                rowspan="2"
              >
                발주 부위
              </th>

              <th
                class="text-center back-8ca9dd color-white border-right-white"
                rowspan="2"
              >
                동
              </th>
              <th
                class="text-center back-8ca9dd color-white border-right-white"
                rowspan="2"
              >
                층
              </th>

              <th
                class="text-center back-8ca9dd color-white border-right-white"
                rowspan="2"
              >
                타입
              </th>
              <th
                class="text-center back-8ca9dd color-white border-right-white"
                rowspan="1"
                :colspan="materialLength"
              >
                규격(단위:TON)
              </th>
              <th
                class="text-center back-8ca9dd color-white  border-right-white"
                rowspan="2"
              >
                합계수량
              </th>
              <th class="text-center back-8ca9dd color-white" rowspan="2">
                입고일자
              </th>
            </tr>
            <tr>
              <th
                class="text-center back-8ca9dd color-white border-top-white border-right-white"
                v-for="(material, index) in materialList"
                :key="index"
              >
                {{ material.rebar_name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                :rowspan="completeList.length + 1"
                class="border-right-aaaaaa  border-bottom-aaaaaa text-center "
              >
                {{ orderName }}
              </td>
              <td
                :rowspan="completeList.length + 1"
                class="border-right-aaaaaa border-bottom-aaaaaa text-center part-btn"
              >
                {{ partName }}
              </td>
            </tr>
            <tr v-for="i of completeList" :key="i.orderId">
              <td class="border-aaaaaa">
                {{ i.dong }}
              </td>
              <td class="border-aaaaaa">
                {{ i.floor }}
              </td>
              <td class="border-aaaaaa">
                {{ i.type }}
              </td>
              <td
                v-for="j of i.rebarList.length"
                :key="j"
                class="text-center border-aaaaaa"
              >
                <input
                  type="number"
                  v-model="i.rebarList[j - 1]"
                  :disabled="viewerRole || closeYn"
                  class="text-center input-number pa-0 border-aaaaaa"
                />
              </td>
              <td class="text-center border-aaaaaa">
                {{ sum(i.rebarList).toFixed(3) }}
              </td>
              <td class="text-center border-aaaaaa">{{ dueDate }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-row>
      <v-card-actions
        class=" align-center text-center  justify-center pa-4"
        v-if="!qrViewer"
      >
        <v-btn
          color="#ffffff"
          class="btn-ff5b5a  ml-3"
          width="150"
          height="40"
          @click="deleteComplete"
          v-if="!closeYn"
          :disabled="viewerRole || closeYn"
        >
          삭제
        </v-btn>

        <v-btn
          color="#8ca9dd"
          class="color-white ml-3"
          width="150"
          height="40"
          @click="confirmComplete"
          v-if="!closeYn"
          :disabled="viewerRole || closeYn"
        >
          확인
        </v-btn>
        <v-btn
          color="#C7C7C7"
          class="color-white ml-3"
          width="150"
          height="40"
          @click="dialog = false"
        >
          닫기
        </v-btn>
      </v-card-actions>
    </div>
  </v-dialog>
</template>

<script>
import CompleteApi from "@/api/CompleteService";
import Commonality from "@/mixin/Commonality";
import VueQRCodeComponent from "vue-qrcode-component";
import DefaultDatePicker from "@/components/DefaultDatePicker.vue";

export default {
  mixins: [Commonality],
  components: {
    "qr-code": VueQRCodeComponent,
    DefaultDatePicker,
  },

  created() {
    this.$bus.$on("completeDetail", (data) => {
      this.$bus.$emit("loadingStart");
      this.qrViewer = false;
      this.invoiceId = data.invoiceId;
      this.completeId = data.completeId;
      this.partName = data.partName;
      this.dong = data.dong;
      this.floor = data.floor;
      this.invoiceCode = data.invoiceCode;
      this.orderName = data.orderName;
      this.closeYn = data.closeYn === "Y" ? true : false;
      this.checkList = [];
      this.reset();
      this.dialog = true;
      this.$bus.$emit("loadingEnd");
    });
  },

  beforeDestroy() {
    this.$bus.$off("completeDetail");
  },

  data: () => ({
    invoiceList: [],
    orderName: "",
    dialog: false,
    invoiceId: "",
    checkList: [],
    qrCode: `${window.location.protocol}//${window.location.host}/qrCode?qrText=`,
    qrViewer: false,
    completion: false,
    dong: "",
    floor: "",
    checkList: "",
    invoiceCode: "",
    partName: "",
    completeList: [],
    dueDate: "",
    date:
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate(),
    modal: false,
    closeYn: null, // 마감여부
  }),

  computed: {
    materialLength() {
      return this.materialList.length;
    },
    constructionName() {
      return this.$store.getters.getConstructionId.constructionName;
    },
    viewerRole() {
      return this.$store.getters.getUserList.roleType === "뷰어";
    },
    constructionId() {
      return this.$store.state.Const.constructionId.constructionId;
    },
  },
  methods: {
    updateReceivedDate(date) {
      this.date = date;
      this.modal = false;
    },
    totalSelect() {
      let trueList = [];
      let falseList = [];
      let trueOrFalse = false;
      for (let i = 0; i < this.invoiceList.rows.length; i++) {
        if (this.checkList[i] != true) trueOrFalse = true;
        trueList.push(true);
        falseList.push(false);
      }
      if (trueOrFalse) this.checkList = trueList;
      else this.checkList = falseList;
    },

    focusClear(val, i, j) {
      if (val != 0) return;
      let list = [];
      for (let k = 0; k < this.invoiceList.rows[i].rebarList.length; k++) {
        if (k != j)
          list.push(this.mathRound(this.invoiceList.rows[i].rebarList[k]));
        else list.push("");
      }
      this.invoiceList.rows[i].rebarList = list;
    },

    async reset() {
      let datas = {
        completeId: this.completeId,
        invoiceId: this.invoiceId,
        constructionId: this.constructionId,
      };
      let res = await CompleteApi.completeDetail(datas);
      this.dueDate = res.data.completeDetail.selectDate;
      this.date = res.data.completeDetail.selectDate;
      this.completeList = res.data.list;
    },
    sumList(payload) {
      let returnValue = 0;
      payload.map((a) => (returnValue += Number(a.rebarQuantity)));
      return this.mathRound(returnValue);
    },

    async confirmComplete() {
      let sendData = [];
      for (let i of this.completeList) {
        let rebarListData = [];
        for (let j = 0; j < i.rebarList.length; j++) {
          rebarListData.push({
            rebarName: this.materialList[j].rebar_name,
            rebarValue: Number(i.rebarList[j]),
          });
        }
        sendData.push({
          rebarListData: rebarListData,
          completeId: i.completeId,
          constructionId: this.constructionId,
          selectDate: this.date,
          orderId: i.orderId,
        });
      }
      let res = await CompleteApi.completeUpdate(sendData);
      let text = "";
      if (res.data.success == "ok") {
        text = "수정이 완료되었습니다.";
      } else {
        const msg = res.data.message
          ? res.data.message
          : "확인후 다시 시도해주세요.";
        text = msg;
      }
      this.$bus.$emit("dialog", text);
      this.$bus.$emit("completeNavigationDuplicated");
      this.dialog = false;
    },

    async deleteComplete() {
      let data = {
        invoiceId: this.invoiceId,
        constructionId: this.constructionId,
      };
      let res = await CompleteApi.completeDelete(data);
      let text;
      if (res.data.success == "ok") {
        text = "삭제가 완료되었습니다.";
      } else {
        const msg = res.data.message
          ? res.data.message
          : "확인후 다시 시도해주세요.";
        text = msg;
      }
      this.$bus.$emit("dialog", text);
      this.$bus.$emit("completeNavigationDuplicated");
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-btn[disabled],
.v-btn:disabled {
  border: 1px solid transparent !important;
}
input[disabled],
input:disabled {
  border: 1px solid rgba(228, 228, 228, 0.795) !important;
}
.input-number {
  width: 60px;
}
.v-data-table__wrapper {
  max-height: 480px;
}

.v-data-table--fixed-header > .v-data-table__wrapper {
  max-height: 480px;
}

.width-350 {
  width: 350px !important;
}

.qr-btn {
  margin-top: 95px;
  margin-right: 15px;
}

.span-setting1 {
  text-align: center;
  background: #dde0e7;
  border-radius: 25px;
  width: 130px;
  height: 38px;
  vertical-align: middle;
}

.span-setting2 {
  text-align: center;
  background: #dde0e7;
  border-radius: 25px;
  width: 216px;
  height: 38px;
  vertical-align: middle;
}

.v-dialog {
  margin: 0px !important;
  overflow-y: hidden !important;
}

.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 0px !important;
}

.part-btn {
  max-width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.dialog-hidden {
  overflow-y: hidden !important;
}

.width-50 {
  width: 50px;
}
.done-text {
  color: #ff2626;
  font-family: "Noto Sans KR";
  font-size: 14px;
}
.info-text {
  color: #666666;
  font-family: "Noto Sans KR";
  font-size: 14px;
}
.area-title {
  font-family: "Noto Sans KR";
  font-size: 18px;
  font-weight: 500;
}
.store-date-title {
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-weight: 500;
}
</style>
